<template>
  <div id="app">
    <WeedMusic msg="WeedMusic" des="A Symphony for your high "/>

    <music v-bind:music="music"/>
  </div>
</template>

<script>
import WeedMusic from './components/WeedMusic.vue'
import music from './components/music.vue'

export default {
  name: 'app',
  components: {
    WeedMusic,
    music
  },
  data() {
    return {
      music: [
        {
          id: 1,
          artist: 'The Rolling Stones',
          album:  'Flowers',
          song:   "Mother's Little Helper",
          src:    "https://embed.music.apple.com/us/album/mothers-little-helper/1440795364?i=1440796130"
        },
        {
          id: 2,
          artist: 'Snoop Dogg',
          album:  'Doggystyle',
          song:   "Who Am I (What's My Name)?",
          src:    "https://embed.music.apple.com/us/album/who-am-i-whats-my-name/6655669?i=6655657"
        },
        {
          id: 3,
          artist: 'A Tribe Called Quest',
          album:  "People's Instinctive Travels and the Paths of Rhythm",
          song:   'Can I Kick It?',
          src:    "https://embed.music.apple.com/us/album/can-i-kick-it/1046921573?i=1046922428"
        },
        {
          id: 4,
          artist: 'Beyoncé',
          album:  'Lemonade',
          song:   'Sorry',
          src:    "https://embed.music.apple.com/us/album/sorry/1460430561?i=1460430677"
        },
        {
          id: 5,
          artist: 'The Flamming Lips',
          album:  'Yoshimi Battles The Pink Robots',
          song:   'Do You Realize??',
          src:    "https://embed.music.apple.com/us/album/do-you-realize/1189403816?i=1189403828"
        },
        {
          id: 6,
          artist: 'Yo-Yo Ma',
          album:  'Bach: Unaccompanied Cello Suites (Remastered)',
          song:   'Prélude',
          src:    "https://embed.music.apple.com/us/album/cello-suite-no-1-in-g-major-bwv-1007-pr%C3%A9lude/381515547?i=381515553"
        },
        {
          id: 7,
          artist: 'Radiohead',
          album:  'In Rainbows',
          song:   'Reckoner',
          src:    "https://embed.music.apple.com/us/album/reckoner/1109714933?i=1109715309"
        },
        {
          id: 8,
          artist: 'David Bowie',
          album:  'David Bowie (2015 Remastered Version)',
          song:   'Space Oddity (2015 Remastered Version)',
          src:    "https://embed.music.apple.com/us/album/space-oddity-2015-remastered-version/1039799506?i=1039800298"
        },
        {
          id: 9,
          artist: 'Vampire Weekend',
          album:  'Vampire Weekend',
          song:   'I Stand Corrected',
          src:    "https://embed.music.apple.com/us/album/i-stand-corrected/270425072?i=270425330"
        },
        {
          id: 10,
          artist: 'Dolly Parton',
          album:  'Jolene',
          song:   'Jolene',
          src:    "https://embed.music.apple.com/us/album/jolene/1062400323?i=1062400330"
        },
        {
          id: 11,
          artist: 'Alabama Shakes',
          album:  'Boys & Girls',
          song:   'Hold On',
          src:    "https://embed.music.apple.com/us/album/hold-on/1072477718?i=1072477719"
        },
        {
          id: 12,
          artist: 'Beck',
          album:  'Guero',
          song:   'Rental Car',
          src:    "https://embed.music.apple.com/us/album/rental-car/1440809859?i=1440810358"
        },
        {
          id: 13,
          artist: 'Kanye West',
          album:  'The College Dropout',
          song:   'Spaceship',
          src:    "https://embed.music.apple.com/us/album/spaceship-feat-glc-consequence/1412872568?i=1412873326"
        },
        {
          id: 14,
          artist: 'Snoop Dogg',
          album:  'Doggystyle',
          song:   "Who Am I (What's My Name)?",
          src:    "https://embed.music.apple.com/us/album/who-am-i-whats-my-name/6655669?i=6655657"
        },
        {
          id: 15,
          artist: 'Outkast',
          album:  'Stankonia',
          song:   "B.O.B.",
          src:    "https://embed.music.apple.com/us/album/b-o-b/255836651?i=255837382"
        },
        {
          id: 16,
          artist: 'Cypress Hill',
          album:  'Black Sunday',
          song:   "Hits from the Bong",
          src:    "https://embed.music.apple.com/us/album/hits-from-the-bong/266797392?i=266797853"
        },
        {
          id: 17,
          artist: 'Dusty Springfield',
          album:  'Dusty In Memphis',
          song:   "Son of a Preacher Man",
          src:    "https://embed.music.apple.com/us/album/son-of-a-preacher-man/257837795?i=257837972"
        },
        {
          id: 18,
          artist: 'Cypress Hill',
          album:  'Black Sunday',
          song:   "Hits from the Bong",
          src:    "https://embed.music.apple.com/us/album/hits-from-the-bong/266797392?i=266797853"
        },

      ]
    }
  }
}
</script>

<style>
#app {
  font-family: 'Righteous', cursive;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
